import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext, useLocation } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { exportExcel } from "../hooks/useExportUtils";
import { ListBox } from "primereact/listbox";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export const BonosTranferencia = ({ Auth }) => {
  const dt = useRef(null);
  const toast = useRef(null);
  const { selectedNomina } = useOutletContext();
  const [listadoBonos, setListadoFaltas] = useState([]);
  const [nominas, setNominas] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(10);
  const [periodosDisponibles, setPeriodosDisponibles] = useState([]);
  //const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const periodoParam = queryParams.get("periodo");
    // if (periodoParam) {
    //   setPeriodoSeleccionado(periodoParam);
    // }
  }, [location.search]);

  const getData = async () => {
    try {
      const resNominas = await axiosPrivate.get("NOM/nominas");
      setNominas(resNominas.data);
      const resPeriodos = await axiosPrivate.get("NOM/bonos/periodos");
      setPeriodosDisponibles(resPeriodos.data);
    } catch (error) {
      console.error("Error al obtener faltas:", error);
    }
  };

  useEffect(() => {
    if (!selectedNomina) return;
    getData();
  }, [selectedNomina]);
  const columns = [
    
    { field: "numero", header: "Número", sortable: true },
    { field: "nombre", header: "Nombre", sortable: true },
    { field: "periodo", header: "Periodo", sortable: true },
    { field: "nomina", header: "Nomina", sortable: true },
    { field: "noConcepto", header: "No. Concepto", sortable: true },
    { field: "concepto", header: "Concepto", sortable: true },
    { field: "valor", header: "Valor", sortable: true },
    
  ];

  const formatFecha = (valor) => {
    if (!valor) return "";
    const fecha = new Date(valor);
    if (isNaN(fecha)) return "";

    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const año = fecha.getFullYear();

    return `${dia}/${mes}/${año}`;
  };
  const dynamicColumns = columns.map((col) => {
    const camposFecha = [
      "created_at",
      "updated_at",
      "fechas",
      "fechaIngreso",
      "fechaBaja",
    ];
    return (
      <Column
        key={col.field}
        field={col.field}
        header={col.header}
        sortable={col.sortable}
        body={
          camposFecha.includes(col.field)
            ? (rowData) => {
                const valor = rowData[col.field];
                if (Array.isArray(valor)) {
                  return valor.map((f) => formatFecha(f)).join(", ");
                }
                return formatFecha(valor);
              }
            : undefined
        }
      />
    );
  });
  const template2 = {
    layout: "RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink",
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 50, value: 50 },
      ];

      return (
        <>
          <span className="mx-2">Items por página:</span>
          <Dropdown
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </>
      );
    },
    CurrentPageReport: (options) => (
      <span className="mx-2">
        {options.first} - {options.last} de {options.totalRecords}
      </span>
    ),
  };

  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  };
  const handleBack = () => {
    navigate(-1);
  };

  const [seleccionados, setSeleccionados] = useState([]);

  const leftToolbarTemplate = () => (
    <div className="flex gap-2 items-center flex-center">
      {/* <label htmlFor="periodo" className="whitespace-nowrap">
        Filtrar por periodo:
      </label>
      <Dropdown
        id="periodo"
        value={periodoSeleccionado}
        options={periodosDisponibles}
        onChange={(e) => setPeriodoSeleccionado(e.value)}
        placeholder="Selecciona periodo"
        className="w-15rem"
        showClear
      /> */}
      <label htmlFor="periodo" className="whitespace-nowrap">
        Seleccione la nomina:
      </label>
      <ListBox
        value={seleccionados}
        options={nominas}
        id="nominas"
        onChange={(e) => setSeleccionados(e.value)}
        multiple
        optionLabel="Nomina"
        optionValue="idNomina"
        metaKeySelection={true}
        checkbox={"checkbox"}
        style={{ width: "20rem" }}
        listStyle={{ maxHeight: "150px" }}
      />
      <Button
        label="Cargar registros"
        icon="pi pi-refresh"
        severity="secondary"
        onClick={() => CargarRegistros(seleccionados)}
      />
    </div>
  );
  const CargarRegistros = (data) => {
    const periodo = `${selectedNomina.YearPeriodo}-${selectedNomina.PeriodoActual
      .toString()
      .padStart(2, "0")}`;
    console.log("Exportando a CargarRegistros:", data, periodo);
    if (!data || data.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Debe seleccionar al menos una nómina",
        life: 3000,
      });
      return;
    }
    if (!periodo) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "Debe seleccionar un periodo",
        life: 3000,
      });
      return;
    }
    axiosPrivate
      .post(`/NOM/bonos/procesar`, {
        nominaIds: data,
        periodo: periodo,
      })
      .then((response) => {
        console.log("Transferencia response:", response.data);
        setListadoFaltas(response.data);
        toast.current.show({
          severity: "success",
          summary: "Éxito",
          detail: response.data.msg,
          life: 3000,
        });
        getData();
      })
      .catch((error) => {
        setListadoFaltas([]);
        console.error("Error al transferir faltas:", error);
        toast.current?.show({
          severity: "warn",
          summary: "Sin resultados",
          detail:
            "No se encontraron faltas ni vacaciones para la nómina y periodo.",
          life: 3000,
        });
      });
  };

  const TransferirBonos = () => {
    if (listadoBonos.length === 0) {
      toast.current.show({
        severity: "warn",
        summary: "Advertencia",
        detail: "No hay bonos para transferir",
        life: 3000,
      });
      return;
    }
    console.log("Transferir bonos:", listadoBonos);
    confirmDialog({
      message: "¿Está seguro de transferir los bonos seleccionados?",
      header: "Confirmación",
      icon: "pi pi-question-circle",
      accept: async () => {
        try {
          //const excepcionIds = listadoFaltas.map((item) => item._id);
          const response = await axiosPrivate.post(`/NOM/bonos/transferir`, {
            registros:listadoBonos,
            periodo: `${selectedNomina.YearPeriodo}-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`, // o como esté tu periodo
          });
          console.log("Transferencia response:", response.data);
          toast.current.show({
            severity: "success",
            summary: "Éxito",
            detail: response.data.msg,
            life: 3000,
          });
        } catch (error) {
          console.error("Error al transferir bonos:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo transferir los bonos",
            life: 3000,
          });
        }
      },
    });
  };

  const handleEdit = (empleado) => {
    console.log("Editar:", empleado);
    navigate(`/faltas/${empleado.id}`);
  };

  const removeRegistro = (excepcion) => {
    confirmDialog({
      message: `¿Estás seguro de quitar el registro de "${excepcion.Nombre}"?`,
      header: "Confirmar remoción",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí, eliminar",
      rejectLabel: "Cancelar",
      accept: async () => {
        try {
          const nuevosDatos = listadoBonos.filter(
            (d) => d._id !== excepcion._id
          );
          setListadoFaltas(nuevosDatos);
        } catch (error) {
          console.error("Error al eliminar:", error);
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo eliminar el empleado",
            life: 3000,
          });
        }
      },
    });
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex gap-2">
        <Button
          icon="pi pi-minus-circle"
          className="p-button-rounded p-button-warning p-button-sm"
          onClick={() => removeRegistro(rowData)}
          tooltip="Remover registro"
        />
      </div>
    );
  };
  return (
    <div className="p-m-4">
      <Toast ref={toast} />
      <ConfirmDialog />
      <Card title="Transferencia de bonos a nómina">
        <div className="mb-3 flex justify-content-between">
          <Button
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-secondary"
            onClick={handleBack}
          />
          <Button
            label="Exportar Excel"
            icon="pi pi-file-excel"
            severity="success"
            onClick={() => exportExcel(listadoBonos, "Bonos")}
          />
          <Button
            label="Transferir"
            icon="pi pi-cog"
            className="p-button-info"
            onClick={() => TransferirBonos()}
          />
        </div>
        <Toolbar
          className="mb-4"
          left={leftToolbarTemplate}
        />
        <DataTable
          ref={dt}
          value={listadoBonos}
          paginator
          paginatorTemplate={template2}
          first={first2}
          rows={rows2}
          onPage={onCustomPage2}
          removableSort
          className="p-datatable-sm"
          stripedRows
          globalFilter={globalFilter}
          globalFilterFields={[
            "numero",
            "Nombre",
            "fechas",
            "periodo",
            "usuario",
          ]}
        >
          {dynamicColumns}
          <Column
            body={actionBodyTemplate}
            header="Acciones"
            style={{ minWidth: "10rem" }}
          />
        </DataTable>
      </Card>
    </div>
  );
};

export default BonosTranferencia;
